"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BUTTON_ICON_ICON_NAME", {
  enumerable: true,
  get: function get() {
    return _Icon.ICON_NAME;
  }
});
exports.BUTTON_ICON_SIZE = void 0;
Object.defineProperty(exports, "BUTTON_ICON_STYLE_TYPE", {
  enumerable: true,
  get: function get() {
    return _Button.BUTTON_STYLE_TYPE;
  }
});
Object.defineProperty(exports, "BUTTON_ICON_TYPE", {
  enumerable: true,
  get: function get() {
    return _Button.BUTTON_TYPE;
  }
});
var _Button = require("b2b-components/theme/components/Button");
var _Icon = require("b2b-components/theme/components/Icon");
var BUTTON_ICON_SIZE = /*#__PURE__*/function (BUTTON_ICON_SIZE) {
  BUTTON_ICON_SIZE["default"] = "default";
  BUTTON_ICON_SIZE["small"] = "small";
  BUTTON_ICON_SIZE["medium"] = "medium";
  BUTTON_ICON_SIZE["xsmall"] = "xsmall";
  return BUTTON_ICON_SIZE;
}(BUTTON_ICON_SIZE || {});
exports.BUTTON_ICON_SIZE = BUTTON_ICON_SIZE;